import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-28d9bddd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "admin-statistic-page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "admin-statistic-page__title" }, "Статистика", -1))
const _hoisted_3 = { class: "admin-statistic-page__date" }
const _hoisted_4 = { class: "admin-statistic-page__content" }
const _hoisted_5 = { class: "admin-statistic-page__content-report-count" }
const _hoisted_6 = { class: "admin-statistic-page__text" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Пародонтология: ")
const _hoisted_8 = { class: "text-bold" }
const _hoisted_9 = { class: "admin-statistic-page__text" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Карта ёршиков: ")
const _hoisted_11 = { class: "text-bold" }
const _hoisted_12 = { class: "admin-statistic-page__text" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Скрининги: ")
const _hoisted_14 = { class: "text-bold" }

import { computed, onMounted, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import UserStatisticChart from '@/pages/admin/AdminStatisticPage/components/UserStatisticChart.vue'
import {
  AdminStatisticType,
  AxiosErrorType,
  StatisticFilterType,
} from '@/shared/types'
import { organizationsApi, usersApi } from '@/shared/api'
import { declination, showErrorMessage } from '@/shared/utils'
import { StatisticResponseType } from '@/pages/admin/AdminStatisticPage/types/statistic.type'
import { useUserListing } from '@/shared/composables'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()

const loading = ref(false)

const dateRange = ref([])
const statistic = ref<AdminStatisticType[]>([])

const periodontalReportsCount = ref(0)
const plaqueReportsCount = ref(0)
const brushMapReportsCount = ref(0)
const screeningReportsCount = ref(0)

const organizationId = computed(() => route.params.organizationId)
const userId = computed(() => route.params.userId)
const { setUpdateUserListing, setUpdateDateUserListing } = useUserListing()

const isOrganizationsPage = computed(() => route.path.includes('organizations'))

const isUserStatistic = computed(() => route.path.includes('/show'))

const totalReportsCount = computed((): number => {
  return statistic.value.reduce(
    (sumReports, statisticItem) => (sumReports += statisticItem.count),
    0
  )
})

const signature = computed(() =>
  declination(totalReportsCount.value, ['отчет', 'отчета', 'отчетов'])
)

watch(organizationId, (newOrganizationId) => {
  if (newOrganizationId && newOrganizationId !== 'all') {
    if (isOrganizationsPage.value) {
      getOrganizationStatistic()
    } else {
      getUserStatistic()
    }
  }
})

watch(userId, (newUserId) => {
  if (newUserId) {
    getUserStatistic()
  }
})

watch(
  () => isUserStatistic.value,
  () => {
    if (organizationId.value) {
      getOrganizationStatistic()
    }
  }
)

const getStatistic = (): void => {
  if (isOrganizationsPage.value) {
    getOrganizationStatistic()
  } else {
    getUserStatistic()
  }
}

const getUserStatistic = async (): Promise<void> => {
  loading.value = true

  const filter: StatisticFilterType = {
    dateFrom: dateRange.value ? dateRange.value[0] : undefined,
    dateTo: dateRange.value ? dateRange.value[1] : undefined,
  }

  const [error, response] = await usersApi.getUserStatistic(
    Number(organizationId.value),
    Number(userId.value),
    filter
  )

  handleResponse(response.data, error)

  loading.value = false
}

const getOrganizationStatistic = async (): Promise<void> => {
  loading.value = true

  const filter: StatisticFilterType = {
    dateFrom: dateRange.value ? dateRange.value[0] : undefined,
    dateTo: dateRange.value ? dateRange.value[1] : undefined,
  }

  setUpdateUserListing(true)
  setUpdateDateUserListing(filter)

  if (userId.value && organizationId.value && organizationId.value !== 'all') {
    const [error, response] =
      await organizationsApi.getOrganizationUserStatistic(
        Number(organizationId.value),
        Number(userId.value),
        filter
      )

    handleResponse(response.data, error)
  } else if (organizationId.value !== 'all') {
    const [error, response] = await organizationsApi.getOrganizationStatistic(
      Number(organizationId.value),
      filter
    )

    handleResponse(response.data, error)
  }

  loading.value = false
}

const handleResponse = (
  response: StatisticResponseType,
  error: AxiosErrorType
): void => {
  if (error) {
    showErrorMessage(error)

    return
  }

  statistic.value = response.statistics

  periodontalReportsCount.value = response.periodontology
    .map((item) => item.count)
    .reduce((acc, count) => acc + count, 0)
  plaqueReportsCount.value = response.statistics
    .map((item) => item.count)
    .reduce((acc, count) => acc + count, 0)
  screeningReportsCount.value = response.screening
    .map((item) => item.count)
    .reduce((acc, count) => acc + count, 0)
  brushMapReportsCount.value = response.brushmap
    .map((item) => item.count)
    .reduce((acc, count) => acc + count, 0)
}

onMounted((): void => {
  getStatistic()
})

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_date_picker, {
        modelValue: dateRange.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dateRange).value = $event)),
        "end-placeholder": "Конец",
        format: "DD.MM.YYYY",
        "start-placeholder": "Начало",
        type: "daterange",
        "value-format": "YYYY-MM-DD",
        onChange: getStatistic
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(totalReportsCount)) + " " + _toDisplayString(_unref(signature)), 1),
      (statistic.value.length)
        ? (_openBlock(), _createBlock(UserStatisticChart, {
            key: statistic.value?.length,
            statistic: statistic.value
          }, null, 8, ["statistic"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("p", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("span", _hoisted_8, " кол-во отчетов за весь период - " + _toDisplayString(periodontalReportsCount.value), 1)
    ]),
    _createElementVNode("p", _hoisted_9, [
      _hoisted_10,
      _createElementVNode("span", _hoisted_11, " кол-во отчетов за весь период - " + _toDisplayString(brushMapReportsCount.value), 1)
    ]),
    _createElementVNode("p", _hoisted_12, [
      _hoisted_13,
      _createElementVNode("span", _hoisted_14, " кол-во отчетов за весь период - " + _toDisplayString(screeningReportsCount.value), 1)
    ])
  ])), [
    [_directive_loading, loading.value]
  ])
}
}

})